import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '@env'
import { TeamComparisonRequest } from '@pages/team/models/team.models'
import { MetricMap } from '@core/models/metric.models'
import { catchObsError } from '@shared/decorators/catch-obs-error.decorator'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { Player } from '@core/models/player.models'
import { Team, TeamComparison } from '@core/models/team.models'
import { Aggregation } from '@features/aggregations/models/aggregations.models'

@Injectable({ providedIn: 'root' })
export class TeamApi {
  private readonly _http: HttpClient = inject(HttpClient)

  @catchObsError()
  fetchTeam(seasonId: string, competitionId: string, teamId: string) {
    return this._http.get<Team>(environment.api.teamsUrlFn(seasonId, competitionId, teamId))
  }

  @catchObsError()
  fetchTeams(seasonId: string, competitionId: string): Observable<{ teams: Team[] }> {
    return this._http.get<{ teams: Team[] }>(environment.api.teamsUrlFn(seasonId, competitionId))
  }

  @catchObsError()
  fetchPlayers(
    seasonId: string,
    competitionId: string,
    teamId: string,
    aggregationDataSource: Aggregation
  ): Observable<Player[]> {
    return this._http
      .get<{ squad: { players: Player[] } }>(environment.api.playersUrlFn(seasonId, competitionId, teamId), {
        params: { aggregationDataSource }
      })
      .pipe(map((response) => response?.squad?.players ?? []))
  }

  @catchObsError()
  compareTeams(payload: TeamComparisonRequest) {
    return this._http.post<TeamComparison>(environment.api.teamsCompareUrl, payload)
  }

  fetchTeamMetrics(
    seasonId: string,
    competitionId: string,
    teamId: string,
    leftAggregationDataSource: Aggregation,
    aggregationDataSource: Aggregation
  ): Observable<MetricMap> {
    return this._http.get<MetricMap>(environment.api.teamMetricResultsUrlFn(seasonId, competitionId, teamId), {
      params: { aggregationDataSource, leftAggregationDataSource }
    })
  }
}
